import React, { useEffect, useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { mockBrands, Brand } from '../data/mockData';
import { SearchIcon, FilterIcon, ChevronDownIcon, ChevronUpIcon, RssIcon, GlobeIcon, TagIcon, MapPinIcon } from 'lucide-react';
import { CustomDropdown } from '../components/CustomDropdown';
export function ExploreBrands() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [languageFilter, setLanguageFilter] = useState('all');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [regionFilter, setRegionFilter] = useState('all');
  const [filteredBrands, setFilteredBrands] = useState<Brand[]>(mockBrands);
  const [expandedBrand, setExpandedBrand] = useState<string | null>(null);
  const languageOptions = [{
    value: 'all',
    label: 'All Languages'
  }, {
    value: 'English',
    label: 'English'
  }, {
    value: 'Spanish',
    label: 'Spanish'
  }, {
    value: 'German',
    label: 'German'
  }, {
    value: 'French',
    label: 'French'
  }, {
    value: 'Ukrainian',
    label: 'Ukrainian'
  }];
  const categoryOptions = [{
    value: 'all',
    label: 'All Categories'
  }, {
    value: 'General News',
    label: 'General News'
  }, {
    value: 'Politics',
    label: 'Politics'
  }, {
    value: 'Business',
    label: 'Business'
  }, {
    value: 'Sports',
    label: 'Sports'
  }, {
    value: 'Entertainment',
    label: 'Entertainment'
  }];
  const regionOptions = [{
    value: 'all',
    label: 'All Regions'
  }, {
    value: 'United States',
    label: 'United States'
  }, {
    value: 'United Kingdom',
    label: 'United Kingdom'
  }, {
    value: 'Europe',
    label: 'Europe'
  }, {
    value: 'Japan',
    label: 'Japan'
  }, {
    value: 'Germany',
    label: 'Germany'
  }, {
    value: 'France',
    label: 'France'
  }, {
    value: 'Ukraine',
    label: 'Ukraine'
  }, {
    value: 'India',
    label: 'India'
  }, {
    value: 'Hong Kong',
    label: 'Hong Kong'
  }];
  useEffect(() => {
    let filtered = mockBrands;
    if (searchQuery) {
      filtered = filtered.filter(brand => brand.name.toLowerCase().includes(searchQuery.toLowerCase()) || brand.description.toLowerCase().includes(searchQuery.toLowerCase()) || brand.category.toLowerCase().includes(searchQuery.toLowerCase()));
    }
    if (languageFilter !== 'all') {
      filtered = filtered.filter(brand => brand.language === languageFilter);
    }
    if (categoryFilter !== 'all') {
      filtered = filtered.filter(brand => brand.category === categoryFilter);
    }
    if (regionFilter !== 'all') {
      filtered = filtered.filter(brand => brand.region === regionFilter);
    }
    setFilteredBrands(filtered);
  }, [searchQuery, languageFilter, categoryFilter, regionFilter]);
  const handleSubscribe = (brand: Brand) => {
    alert(`Subscribed to ${brand.name}!`);
  };
  const toggleBrandExpansion = (brandId: string) => {
    setExpandedBrand(expandedBrand === brandId ? null : brandId);
  };
  const handleViewStories = (brand: Brand) => {
    navigate(`/explore?brand=${encodeURIComponent(brand.name)}`);
  };
  return <div className="space-y-6" data-id="element-237">
      {/* Header */}
      <div className="rounded-2xl p-8 text-white shadow-card-lg" style={{
      background: 'linear-gradient(135deg, #1e3a52 0%, #182941 50%, #12202f 100%)'
    }} data-id="element-238">
        <h1 className="text-4xl font-bold text-display mb-2 !text-white" data-id="element-239">
          Explore Publishers
        </h1>
        <p className="text-lg text-white" data-id="element-240">
          Discover and subscribe to news publishers from the INN News Network
        </p>
      </div>
      {/* Search and Filters */}
      <div className="bg-white rounded-xl p-6 shadow-card border border-neutral-200" data-id="element-241">
        <div className="flex items-center gap-3 mb-4" data-id="element-242">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
        }} data-id="element-243">
            <FilterIcon className="w-4 h-4 text-white" data-id="element-244" />
          </div>
          <h3 className="text-lg font-semibold text-neutral-900" data-id="element-245">
            Search & Filters
          </h3>
        </div>
        <div className="grid grid-cols-[2fr_1fr_1fr_1fr] gap-4" data-id="element-246">
          <div className="relative" data-id="element-247">
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400" data-id="element-248" />
            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search by brand name, category, or description..." className="w-full pl-12 pr-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all" data-id="element-249" />
          </div>
          <CustomDropdown value={languageFilter} onChange={setLanguageFilter} options={languageOptions} placeholder="Language" data-id="element-250" />
          <CustomDropdown value={categoryFilter} onChange={setCategoryFilter} options={categoryOptions} placeholder="Category" data-id="element-251" />
          <CustomDropdown value={regionFilter} onChange={setRegionFilter} options={regionOptions} placeholder="Region" data-id="element-252" />
        </div>
      </div>
      {/* Results Count */}
      <div className="flex items-center justify-between" data-id="element-253">
        <p className="text-sm text-neutral-600" data-id="element-254">
          <span className="font-semibold" style={{
          color: '#0289BB'
        }} data-id="element-255">
            {filteredBrands.length}
          </span>{' '}
          brands found
        </p>
      </div>
      {/* Brands Grid */}
      <div className="grid grid-cols-3 gap-6" data-id="element-256">
        {filteredBrands.length === 0 ? <div className="col-span-3 bg-white rounded-xl p-12 shadow-card border border-neutral-200 text-center" data-id="element-257">
            <p className="text-neutral-500 text-lg" data-id="element-258">
              No brands found matching your criteria.
            </p>
          </div> : filteredBrands.map(brand => <div key={brand.id} className="bg-white rounded-xl p-6 shadow-card hover:shadow-card-hover transition-all border border-neutral-200" data-id="element-259">
              <div className="flex items-start gap-4 mb-4" data-id="element-260">
                <img src={brand.logo} alt={brand.name} className="w-16 h-16 rounded-lg object-cover border border-neutral-200" data-id="element-261" />
                <div className="flex-1 min-w-0" data-id="element-262">
                  <h3 className="text-lg font-bold text-display text-neutral-900 mb-1 truncate" data-id="element-263">
                    {brand.name}
                  </h3>
                  <div className="flex items-center gap-2 flex-wrap" data-id="element-264">
                    <span className="inline-block px-2 py-1 text-white rounded text-xs font-semibold" style={{
                background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
              }} data-id="element-265">
                      {brand.category}
                    </span>
                    {brand.feedUrl && <span className="inline-block px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-semibold flex items-center gap-1" data-id="element-266">
                        <RssIcon className="w-3 h-3" data-id="element-267" />
                        RSS
                      </span>}
                  </div>
                </div>
              </div>
              <p className="text-sm text-neutral-600 mb-4 line-clamp-2" data-id="element-268">
                {brand.description}
              </p>
              <div className="flex items-center justify-between text-xs text-neutral-500 mb-4" data-id="element-269">
                <span data-id="element-270">{brand.language}</span>
                <span data-id="element-271">•</span>
                <span data-id="element-272">{brand.region}</span>
                <span data-id="element-273">•</span>
                <span className="font-semibold text-blue-700" data-id="element-274">
                  {brand.storyCount.toLocaleString()} stories
                </span>
              </div>
              {/* Recent Stories Section */}
              {brand.stories && brand.stories.length > 0 && <div className="mb-4" data-id="element-275">
                  <button onClick={() => toggleBrandExpansion(brand.id)} className="w-full flex items-center justify-between py-2 px-3 bg-neutral-50 hover:bg-neutral-100 rounded-lg transition-all text-sm font-medium text-neutral-700" data-id="element-276">
                    <span data-id="element-277">Recent Stories ({brand.stories.length})</span>
                    {expandedBrand === brand.id ? <ChevronUpIcon className="w-4 h-4" data-id="element-278" /> : <ChevronDownIcon className="w-4 h-4" data-id="element-279" />}
                  </button>
                  {expandedBrand === brand.id && <div className="mt-3 space-y-2" data-id="element-280">
                      {brand.stories.map(story => <div key={story.id} className="p-3 bg-neutral-50 rounded-lg border border-neutral-200" data-id="element-281">
                          <h4 className="text-sm font-semibold text-neutral-900 mb-1 line-clamp-2" data-id="element-282">
                            {story.title}
                          </h4>
                          <p className="text-xs text-neutral-600 line-clamp-2 mb-2" data-id="element-283">
                            {story.excerpt}
                          </p>
                          <div className="flex items-center gap-2 text-xs text-neutral-500" data-id="element-284">
                            <span className="px-2 py-0.5 rounded font-medium" style={{
                  backgroundColor: 'rgba(2, 137, 187, 0.1)',
                  color: '#0289BB'
                }} data-id="element-285">
                              {story.category}
                            </span>
                            <span data-id="element-286">•</span>
                            <span data-id="element-287">
                              {new Date(story.date).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                  })}
                            </span>
                          </div>
                        </div>)}
                    </div>}
                </div>}
              <button onClick={() => handleViewStories(brand)} className="w-full py-2.5 text-white rounded-lg hover:shadow-md transition-all font-medium text-sm" style={{
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
        }} data-id="element-288">
                View All Stories
              </button>
            </div>)}
      </div>
    </div>;
}